<template>
  <div class="date-selector-wrapper">
    <v-dialog
      v-model="showModalDatePicker"
      contentClass="datepicker-modal-div"
      persistent
      width="500px"
    >
      <v-card flat>
        <v-card-title class="headline">Select start and end dates:</v-card-title>
        <v-card-text>
          <div persistent width="500px">
            <v-date-picker
              v-model="dateRangeLocal"
              fullWidth
              multiple="range"
              :min="minDate"
              :max="maxDate"
              scrollable
              headerColor="#e4f3ff"
            >
              <v-spacer>{{ showDatepickerModal }}</v-spacer>
            </v-date-picker>
          </div>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn class="cancel-btn" variant="outlined" width="100px" @click="cancelDatePickerModal"
            >Cancel</v-btn
          >
          <v-btn variant="flat" color="accent" style="width: 120px" @click="setSelectedDates()"
            >Apply</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="date-selector date-selector-end">
      <v-text-field
        :modelValue="renderDate"
        placeholder="Select dates"
        readonly
        persistentPlaceholder
        :variant="outlined ? 'outlined' : undefined"
        density="compact"
        hideDetails
        style="width: 220px"
        bgColor="#fff"
        @click.stop="showModalDatePicker = true"
        @vue:Mounted="showModalDatePicker = true"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import { convertToOldVuetify } from "@/utils/DateUtils";
import dayjs from "dayjs";

export default {
  name: "RfCustomMetricsDatePicker",
  props: ["min_date", "max_date", "modelValue", "modalDatePicker", "outlined"],
  data() {
    return {
      minDate: this.min_date ? new Date(this.min_date).toISOString().substr(0, 10) : null,
      maxDate: this.max_date ? new Date(this.max_date).toISOString().substr(0, 10) : null,
      dateRange: [],
      startDate: null,
      endDate: null,
      currStartDate: null,
      showModalDatePicker: false,
    };
  },
  computed: {
    dateRangeLocal: {
      get() {
        if (this.dateRange.length === 1)
          return [dayjs(this.dateRange[0]).toDate(), dayjs(this.dateRange[0]).toDate()];
        if (this.dateRange.length === 0) return [];

        const start = dayjs(this.dateRange[0]);
        const end = dayjs(this.dateRange[1]);

        return Array.from({ length: end.diff(start, "day") + 1 }, (_, i) =>
          start.add(i, "day").toDate(),
        );
      },
      set(value) {
        if (value.length === 0) return (this.dateRange = []);
        if (value.length === 1)
          return (this.dateRange = [convertToOldVuetify(value[0]), convertToOldVuetify(value[0])]);

        return (this.dateRange = [
          convertToOldVuetify(value[0]),
          convertToOldVuetify(value.at(-1)),
        ]);
      },
    },
    renderDate() {
      return this.startDate
        ? `${dayjs(this.startDate).format("MMM Do, YYYY")} - ${dayjs(this.endDate).format(
            "MMM Do, YYYY",
          )}`
        : "";
    },
  },
  watch: {
    dateRange(to) {
      this.currStartDate = to;
      this.reorderDates(to);
    },
  },
  mounted() {
    if (this.modelValue) {
      this.dateRange = this.modelValue;
      this.setDateRangeDisplay(this.dateRange);
    }
  },
  methods: {
    setSelectedDates() {
      this.showModalDatePicker = false;
      if (!this.renderDate) {
        this.$emit("closeCustomDateRange");
      }
      this.setDateRangeDisplay(this.currStartDate);
    },
    cancelDatePickerModal() {
      this.showModalDatePicker = false;
      if (!this.renderDate) {
        this.$emit("closeCustomDateRange");
      }
    },
    setDateRangeDisplay(dates) {
      this.$emit("update:modelValue", this.reorderDates(dates));
    },
    reorderDates(dates) {
      return dates.slice().sort((a, b) => {
        if (new Date(a) > new Date(b)) {
          this.endDate = a;
          this.startDate = b;
        } else {
          this.startDate = a;
          this.endDate = b;
        }
        return new Date(a) - new Date(b);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.date-selector-wrapper {
  padding: 0;
}
</style>
